import type { MembershipDto } from "../../shared/api-types";

// More restaurants per account (owner 2026-11-04): the restaurant the app shows is remembered in this browser.
// Unknown or missing → the account's first restaurant.

const KEY = "mnv-restaurant";

export function currentRestaurantId(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function rememberRestaurant(id: string) {
  try {
    localStorage.setItem(KEY, id);
  } catch {
    // Private mode: the app opens the first restaurant next time.
  }
}

export function pickMembership(list: MembershipDto[]): MembershipDto | undefined {
  const id = currentRestaurantId();
  return list.find((m) => m.restaurant.id === id) ?? list[0];
}

/** Opens another restaurant: a fresh start of the app, so nothing of the previous one stays on screen. */
export function switchRestaurant(id: string, path = "/app") {
  rememberRestaurant(id);
  window.location.assign(path);
}
